import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Box, FormControl, MenuItem, Select } from '@mui/material';

import styles from './site.module.css';

const pageGroups = {
  sports: [
    {
      name: 'Picture-in-Picture',
      page: 'pip',
      //   src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-sports-pip.mp4',
      src: 'https://tl-open-content.s3.amazonaws.com/web-assets/demo-sports-pip-optimized.mp4',
    },
    {
      name: 'Programmatic',
      page: 'programmatic',
      //   src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-sports-progamatic.mp4',
      src: 'https://tl-open-content.s3.amazonaws.com/web-assets/demo-sports-progamatic-optimized.mp4',
    },
    {
      name: 'Home Team Event',
      page: 'home-team-event',
      //   src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-sports-home-team-event.mp4',
      src: 'https://tl-open-content.s3.amazonaws.com/web-assets/demo-sports-home-team-event-optimized.mp4',
    },
    {
      name: 'In-Play Event',
      page: 'in-play-event',
      //   src: 'https://tl-open-content.s3.amazonaws.com/web-assets/demo-sports-in-play-event.mp4',
      src: 'https://tl-open-content.s3.amazonaws.com/web-assets/demo-sports-in-play-event-optimized.mp4',
    },
  ],
  entertainment: [
    {
      name: 'Sponsored Overlay',
      page: 'sponsored-overlay',
      //   src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-entertainment-sponsored-overlay.mp4',
      src: 'https://tl-open-content.s3.amazonaws.com/web-assets/demo-entertainment-sponsored-overlay-optimized.mp4',
    },
    {
      name: 'Subscription Overlay',
      page: 'subscription-overlay',
      //   src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-entertainment-subscription-overlay.mp4',
      src: 'https://tl-open-content.s3.amazonaws.com/web-assets/demo-entertainment-subscription-overlay-optimized.mp4',
    },
    {
      name: 'Stream Session Sponsorship',
      page: 'stream-session-sponsorship',
      //   src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-entertainment-stream-session-sponsorship.mp4',
      src: 'https://tl-open-content.s3.amazonaws.com/web-assets/demo-entertainment-stream-session-sponsorship-optimized.mp4',
    },
  ],
  news: [
    {
      name: 'Overlay',
      page: 'overlay',
      //   src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-news-overlay.mp4',
      src: 'https://tl-open-content.s3.amazonaws.com/web-assets/demo-news-overlay-optimized.mp4',
    },
    {
      name: 'Border Frame',
      page: 'boreder-frame',
      //   src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-news-border-frame.mp4',
      src: 'https://tl-open-content.s3.amazonaws.com/web-assets/demo-news-border-frame-optimized.mp4',
    },
  ],
  extension: [
    {
      name: 'Game Day Highlighter',
      page: 'game-day-highlighter',
      //   src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-extension-game-day-highlighter.mp4',
      src: 'https://tl-open-content.s3.amazonaws.com/web-assets/demo-extension-game-day-highlighter-optimized.mp4',
    },
    {
      name: 'Next On',
      page: 'next-on',
      //   src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-extension-next-on.mp4',
      src: 'https://tl-open-content.s3.amazonaws.com/web-assets/demo-extension-next-on-optimized.mp4',
    },
  ],
};

const DemoPlayer = ({ category }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    const hasCategoryPage = pathname.split('/').filter(Boolean).length >= 3;
    if (!hasCategoryPage) {
      const [{ page: categoryPage }] = pageGroups[category];
      navigate(categoryPage);
    }
  }, [category]);

  const pages = pageGroups[category] || pageGroups[Object.keys(pageGroups)[0]] || [];

  const src = pages.find(({ page }) => {
    return page === pathname.split('/').pop();
  });
  const { src: videoSrc, name: pageName } = src || pages[0] || {};

  return (
    <div className={classNames(styles.mt, styles.flex, styles.justifyCenter)}>
      <Box className={styles.demoPlayerContainer}>
        <div className={styles.demoAdFormatSelectWrapper}>
          <div className={styles.demoAdFormatSelectContainer}>
            <p>Ad Format:</p>
            <FormControl fullWidth>
              <Select
                className={styles.demoAdFormatSelect}
                id="demo-simple-select"
                value={pageName}
                onChange={() => {}}
              >
                {pages.map(({ name, page, src: currentSrc }) => {
                  return (
                    <MenuItem
                      key={page}
                      selected={videoSrc === currentSrc}
                      onClick={() => navigate(`/demo/${category}/${page}`)}
                      value={name}
                    >
                      {name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
        </div>

        <Box sx={{ width: '100%' }} className={classNames(styles.mt2, styles.flex, styles.justifyCenter)}>
          <div style={{ height: 'auto', width: '100%', maxWidth: 810, maxHeight: 456 }}>
            {videoSrc ? (
              <video
                style={{ borderRadius: 24 }}
                src={videoSrc}
                width="100%"
                height="100%"
                loop
                playsInline
                autoPlay
                muted
                controls
              />
            ) : (
              <Box />
            )}
          </div>
        </Box>
      </Box>
    </div>
  );
};

DemoPlayer.propTypes = {
  category: PropTypes.string.isRequired,
};

export default DemoPlayer;
